import React from 'react';
import { Redirect } from 'react-router';
import { NavLink } from 'react-router-dom';
import AudioVerification from './AudioVerification';
import DashboardText from './DashboardText';
import { Badge } from 'reactstrap';

class Dashboard extends React.Component {
    // constructor(props) {
    //     super(props);
    // }

    // render() {
    //     if (!this.props.user.isAuthenticated) {
    //         return (
    //             <Redirect to='/' />
    //         );
    //     }
    //     return (
    //         <div className="container">
    //             <div className="mt-2">
    //                 <Badge color="info">Check your Rank in Menu</Badge>
    //             </div>
    //             <div>
    //                 <p style={{ margin: 0 }}>
    //                     <small>
    //                         <strong>Info:</strong> <span style={{ color: "#dc3545" }}>Use <strong>Chrome</strong> browser</span>
    //                     </small>
    //                 </p>
    //                 <p style={{ margin: 0 }}>
    //                     <small>
    //                         <strong>Record Not Working? </strong><NavLink to="/fixRecording" target="_blank">Click Here</NavLink>
    //                     </small>
    //                 </p>
    //             </div>
    //             <DashboardText
    //                 user={this.props.user}
    //                 logoutUser={this.props.logoutUser}
    //                 uploadAudio={this.props.uploadAudio}
    //                 downloadAudio={this.props.downloadAudio}
    //                 downloadHindiText={this.props.downloadHindiText}
    //                 hindiText={this.props.hindiText}
    //                 updateStatsServer={this.props.updateStatsServer}
    //                 getStats={this.props.getStats}
    //             />
    //             {/* 
    //             <AudioVerification
    //             user={this.props.user}
    //             getAudioForVerification={this.props.getAudioForVerification}
    //             audioVerificationResult={this.props.audioVerificationResult}
    //             updateStatsServer={this.props.updateStatsServer}
    //             getStats={this.props.getStats}/>
    //              */}
                
    //             <div className="mt-2">
    //                 <p style={{ margin: 0 }}>
    //                     <small>
    //                         <strong>Note 1:</strong> <span style={{ color: "#dc3545" }}>Do not Speak as soon as you press Record. To Prevent Cutting the first word</span>
    //                     </small>
    //                 </p>
    //                 <p style={{ margin: 0 }}>
    //                     <small>
    //                         <strong>नोट 1:</strong> <span style={{ color: "#dc3545" }}>रिकॉर्ड दबाने के तुरंत बाद ना बोले। इससे पहला शब्द कट सकता है।</span>
    //                     </small>
    //                 </p>
    //                 <p style={{ margin: 0 }}>
    //                     <small>
    //                         <strong>Note 2:</strong> <span style={{ color: "#dc3545" }}>Do not press Stop Recording as soon as you stop Speaking. To Prevent Cutting the last word.</span>
    //                     </small>
    //                 </p>
    //                 <p style={{ margin: 0 }}>
    //                     <small>
    //                         <strong>नोट 2:</strong> <span style={{ color: "#dc3545" }}>वाक्य बोलने के बाद तुरंत स्टॉप बटन ना दबाए। इससे आखिरी शब्द कट सकता है।</span>
    //                     </small>
    //                 </p>
    //             </div>
    //         </div>
    //     );
    // }

    constructor(props) {
        super(props);
        this.state = {
            currentTab: 'record', // 'record' or 'verify'
        };
    }

    toggleTab = (tab) => {
        this.setState({ currentTab: tab });
    };

    render() {
        if (!this.props.user.isAuthenticated) {
            return <Redirect to='/' />;
        }

        return (
            <div className="container">
                {/* Tab Navigation */}
                <div className="flex gap-4 mb-4">
                    <button
                        onClick={() => this.toggleTab('record')}
                        className={`px-4 py-2 rounded ${
                            this.state.currentTab === 'record' 
                                ? 'bg-blue-600 text-white' 
                                : 'bg-gray-200'
                        }`}
                    >
                        Record Audio
                    </button>
                    <button
                        onClick={() => this.toggleTab('verify')}
                        className={`px-4 py-2 rounded ${
                            this.state.currentTab === 'verify' 
                                ? 'bg-blue-600 text-white' 
                                : 'bg-gray-200'
                        }`}
                    >
                        Verify Audio
                    </button>
                </div>

                {/* Content Area */}
                {this.state.currentTab === 'record' ? (
                    <DashboardText
                        user={this.props.user}
                        logoutUser={this.props.logoutUser}
                        uploadAudio={this.props.uploadAudio}
                        downloadAudio={this.props.downloadAudio}
                        downloadHindiText={this.props.downloadHindiText}
                        hindiText={this.props.hindiText}
                        updateStatsServer={this.props.updateStatsServer}
                        getStats={this.props.getStats}
                    />
                ) : (
                    <AudioVerification
                        user={this.props.user}
                        getAudioForVerification={this.props.getAudioForVerification}
                        audioVerificationResult={this.props.audioVerificationResult}
                        updateStatsServer={this.props.updateStatsServer}
                        getStats={this.props.getStats}
                    />
                )}
            </div>
        );
    }
}

export default Dashboard;